const normalizedFax = (value) => String(value || '').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');

// Keep the open viewer and visible rows coherent while the normal silent refresh
// runs. Never substitute an address-book number for the fax's original source.
const applySenderContact = (state, { contact, record }) => {
  const updateRow = (row) => {
    const details = row?.sender_contact_details;
    if (row?.receiver_type !== 'received_fax' || !details) return row;
    const source = record?.sender_contact_details?.source_fax_id
      && details.source_fax_id === record.sender_contact_details.source_fax_id && !details.personal;
    const sameContact = details.contact?.id === contact.id;
    const sameNumber = normalizedFax(row.sender_email) === normalizedFax(contact.contact);
    const linked = sameContact && details.linked && !details.personal;
    if (sameContact && !source && !linked && !sameNumber) {
      // Number-based matches stop identifying the old fax when a contact moves.
      // Only an explicit shared association can survive a number change.
      return {
        ...row,
        sender_name: row.sender_name_sources ? (row.sender_name_sources.caller_name || '') : row.sender_name,
        sender_contact_details: {
          ...details, contact: null, match_count: Math.max(0, details.match_count - 1), linked: false,
        },
        ...(row.sender_name_sources ? {
          sender_name_sources: { ...row.sender_name_sources, contact_organization: null, contact_name: null },
        } : {}),
      };
    }
    const uniqueNumber = !details.contact && details.match_count < 2 && sameNumber;
    if (!source && !linked && !(sameContact && sameNumber) && !uniqueNumber) return row;
    return {
      ...row,
      sender_name: source || linked ? (contact.organization_name || row.sender_name_sources?.caller_name || row.sender_name) : row.sender_name,
      sender_contact_details: { ...details, contact, linked: Boolean(source || linked) },
      ...(row.sender_name_sources ? {
        sender_name_sources: {
          ...row.sender_name_sources,
          contact_organization: contact.organization_name,
          contact_name: contact.contact_name,
        },
      } : {}),
    };
  };
  const selected = updateRow(state.selectedRecordDetails);
  const collections = {};
  ['received_data', 'referred_data', 'assigned_data'].forEach((key) => {
    const rows = state[key].map(updateRow);
    collections[key] = rows.some((row, index) => row !== state[key][index]) ? rows : state[key];
  });
  if (selected === state.selectedRecordDetails && Object.keys(collections).every((key) => collections[key] === state[key])) return state;
  return {
    ...state,
    ...collections,
    selectedRecordDetails: selected,
    ...(selected !== state.selectedRecordDetails ? {
      senderOrganization: selected.sender_contact_details.contact?.organization_name
        || selected.sender_contact_details.contact?.contact_name || selected.sender_name,
      senderName: selected.sender_contact_details.contact?.contact_name || '',
    } : {}),
    inboxRefreshNonce: state.inboxRefreshNonce + 1,
  };
};

export default applySenderContact;
